module.exports = __webpack_public_path__ + "img/extended.48ed683a.png";